import { createContext, useContext, useState, useEffect } from "react";
import Fetch from "../services/fetchService";
import AuthData from "../common/AuthData";

const DataContex = createContext();

export const DataProvider = ({ children }) => {
    const [data,setData] = useState(null);

    const fetchData = async () => {

        const authData = AuthData.getAuthData();

        const url = `${authData.appFunctionUrl}/api/GetAppDataFunction?code=${authData.azureFunctionKey}`;

        const response = await Fetch(url, authData.clientId);        
        setData(response);
    }
    
    useEffect(() => {
        // localStorage.getItem('user') && fetchData();
    }, []);

    return (
        <DataContex.Provider value={{data, fetchData}}>
            {children}
        </DataContex.Provider>
    );
}

export const useData = () => {
    const context = useContext(DataContex);
    if (context === undefined) {
        throw new Error("useData must be used within a DataProvider");
    }
    return context;
}